<template>
  <zb-radio-group
    :action="plansAction"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="slot in Object.keys({...$scopedSlots, ...$slots})" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </zb-radio-group>
</template>
<script>
import ZbRadioGroup from '@/components/zoom-ui-plus/radio/radio-group.vue';

export default {
  name: 'CategoryRadioGroup',
  props: {
    plans: Array,
    action: Function,
  },
  methods: {
    plansAction(oldVal, val) {
      const oldPlan = this.plans.find(item => item.category === oldVal);
      const newPlan = this.plans.find(item => item.category === val);
      return this.action(oldPlan, newPlan);
    }
  },
  components: {
    ZbRadioGroup,
  },
}
</script>
